import styled from 'styled-components';

export const TBody = styled.div`
  color: ${props => props.theme.textColor};
`;
